import _ from "lodash";
import { FeberApiClient } from "../../services/commonServices";
import { removeAliasDomain } from "../../utils/converter";
import Constants from "../../core/libraries/Constants";

export const getBookmarks = async (isAdminMode: boolean) => {
    let response = await FeberApiClient.get("Bookmark", {
        params: {
            isAdminMode: isAdminMode,
        }
    })
    return !!response.data && !!response.data.success && response.data.data
}

export const getMyBookmarks = async () => {
    let response = (await FeberApiClient.get("Bookmark/GetMine")).data
    let bookmarks = !!response && !!response.success && response.data
    sessionStorage.setItem(Constants.SESSION_STORAGE_KEYS.myBookmarks, JSON.stringify(bookmarks))
    return bookmarks
}

export const removeBookmark = async (bookmarkId: number, isAdminMode: boolean = false) => {
    let response = await FeberApiClient.delete("Bookmark", {
        params: {
            bookmarkId: bookmarkId,
            isAdminMode: isAdminMode,
        }
    })
    return response.data.success
}

export const removeMyBookmark = async (reportId: string) => {
    let response = await FeberApiClient.delete("Bookmark/RemoveMine", {
        params: {
            reportId: reportId,
        }
    })
    return response.data.success
}

export const addBookmark = async (reportId: string, peopleId: string): Promise<any> => {
    let response = await FeberApiClient.post("Bookmark", {
        reportId: reportId,
        createdBy: removeAliasDomain(peopleId)
    })
    return response.data.success
}

export const checkIsBookmarked = async (reportId: string, peopleId: string) => {
    let response = await FeberApiClient.get("Bookmark/IsBookmarked", {
        params: {
            reportId: reportId,
            peopleId: removeAliasDomain(peopleId)
        }
    })
    return !!response.data && !!response.data.success && response.data.data
}